import { QueryClient } from '@tanstack/react-query';
import type { ApiError } from './api.js';

// Register ApiError as TanStack Query's default error type so every useQuery
// sees `query.error` typed as ApiError without a per-call generic.
declare module '@tanstack/react-query' {
  interface Register {
    defaultError: ApiError;
  }
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: { retry: 0 },
    },
  });
}
